module.exports = __webpack_public_path__ + "svg/arrow-album.svg?391d49b3c8b898bc1962cd735954d107";